import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, vShow as _vShow, withCtx as _withCtx, withDirectives as _withDirectives, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "img-home" }
const _hoisted_2 = {
  key: 0,
  class: "img-description pt-5 pr-5 pl-5 t-blue"
}
const _hoisted_3 = { class: "d-flex j-content-s-be a-i-start" }
const _hoisted_4 = { class: "d-flex direction-column pl-5 description-slider" }
const _hoisted_5 = { class: "title-very-big uppercase mt-5 pt-5 ml-4 text-start big text-border-white" }
const _hoisted_6 = { class: "text-raleway-32 pt-3 text-start text-nowrap start-description text-border-white" }
const _hoisted_7 = { class: "d-flex mt-5 direction-row a-i-center information-start-wrapper" }
const _hoisted_8 = { class: "d-flex direction-column" }
const _hoisted_9 = {
  key: 1,
  class: "img-description pt-5 pr-5 pl-5 t-blue"
}
const _hoisted_10 = { class: "d-flex j-content-s-be a-i-start t-blue" }
const _hoisted_11 = { class: "d-flex direction-column pl-5 description-slider" }
const _hoisted_12 = { class: "title-very-big uppercase mt-5 pt-5 ml-4 text-start big text-border-white" }
const _hoisted_13 = { class: "text-raleway-32 pt-3 text-start text-nowrap start-description text-border-white" }
const _hoisted_14 = { class: "d-flex mt-5 direction-row a-i-center information-start-wrapper" }

import CarouselComponent from "@/components/carousel/CarouselComponent.vue";
import { changeComponentAuthorization } from "@/utils/component/component";
import { SeoDescription, SeoTitle } from "@/utils/seo/seo";
import { computed, ref, onBeforeMount, watch } from "vue";
import { store } from "@/store";


export default /*#__PURE__*/_defineComponent({
  __name: 'StartView',
  setup(__props) {

const serverType = ref(computed<string>(() => store.getters.getServerType));

const token = ref(computed<string>(() => store.getters.accessTokenGet));
const imgArray = ref([
  "logoStartPage/A.mp4",
  "logoStartPage/B.png",
  "logoStartPage/C.mp4",
  "logoStartPage/D.png",
]);
const uiLang = ref(computed<string>(() => store.getters.getUserUiLang));
onBeforeMount(() => {
  SeoTitle("Tyre point");
  switch (uiLang.value.toUpperCase()) {
    case "SWEDISH":
      SeoDescription(
        "Tire Points nätbutik säljer bildäck. Vi erbjuder ett brett utbud av rabatterade däck och fälgar i Europa."
      );
      break;
    case "FINLAND":
      SeoDescription(
        "Tyre Point - verkkokauppa myy autonrenkaita. Tarjoamme laajan valikoiman edullisia renkaita ja vanteita Euroopassa."
      );
      break;
    default:
      SeoDescription(
        "The Tyre Point online store sells car tires. We offer a wide range of discount tires and rims in Europe."
      );
      break;
  }
});

watch(
  () => uiLang.value,
  () => {
    SeoTitle("Tyre point");
    switch (uiLang.value.toUpperCase()) {
      case "SWEDISH":
        SeoDescription(
          "Tire Points nätbutik säljer bildäck. Vi erbjuder ett brett utbud av rabatterade däck och fälgar i Europa."
        );
        break;
      case "FINLAND":
        SeoDescription(
          "Tyre Point - verkkokauppa myy autonrenkaita. Tarjoamme laajan valikoiman edullisia renkaita ja vanteita Euroopassa."
        );
        break;
      default:
        SeoDescription(
          "The Tyre Point online store sells car tires. We offer a wide range of discount tires and rims in Europe."
        );
        break;
    }
  },
  {
    deep: true,
  }
);

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(CarouselComponent, { array: imgArray.value }, null, 8, ["array"])
    ]),
    (serverType.value === 'retail')
      ? (_openBlock(), _createElementBlock("section", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$tc("title_home")), 1),
              _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$tc("title_description")), 1),
              _createElementVNode("div", _hoisted_7, [
                _withDirectives(_createVNode(_component_router_link, {
                  type: "submit",
                  class: "btn btn-default mt-4 btn-default-big start-button text-decoration-none d-flex a-i-center",
                  to: { name: 'search' }
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$tc("Shop_tires")), 1)
                  ]),
                  _: 1
                }, 512), [
                  [_vShow, token.value]
                ]),
                _withDirectives(_createVNode(_component_router_link, {
                  class: "p-1 text-decoration-line text-raleway-24 mt-3 information-start",
                  to: { name: 'private_policy' }
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$tc("Lear_more")), 1)
                  ]),
                  _: 1
                }, 512), [
                  [_vShow, token.value]
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _withDirectives(_createVNode(_component_router_link, {
                    class: "btn btn-default btn-default-big start-button button-search-start text-decoration-none btn-tires",
                    to: { name: 'new_orders' }
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$tc("Shop_tires")), 1)
                    ]),
                    _: 1
                  }, 512), [
                    [_vShow, !token.value]
                  ]),
                  _withDirectives(_createVNode(_component_router_link, {
                    type: "submit",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(changeComponentAuthorization)('login_component'))),
                    class: "d-flex a-i-center btn btn-default mt-4 btn-default-big start-button text-decoration-none text-center j-content-center btn-login",
                    to: { name: 'auth' }
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$tc("login")), 1)
                    ]),
                    _: 1
                  }, 512), [
                    [_vShow, !token.value]
                  ])
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (serverType.value !== 'retail')
      ? (_openBlock(), _createElementBlock("section", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.$tc("title_home")), 1),
              _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.$tc("title_description")), 1),
              _createElementVNode("div", _hoisted_14, [
                _withDirectives(_createVNode(_component_router_link, {
                  type: "submit",
                  class: "btn btn-default mt-4 btn-default-big start-button text-decoration-none d-flex a-i-center",
                  to: { name: 'search' }
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$tc("Shop_tires")), 1)
                  ]),
                  _: 1
                }, 512), [
                  [_vShow, token.value]
                ]),
                _withDirectives(_createVNode(_component_router_link, {
                  class: "d-flex a-i-center btn btn-default btn-blue ml-4 mt-4 btn-default-big start-button text-decoration-none text-center j-content-center",
                  to: { name: 'private_policy' }
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$tc("Lear_more")), 1)
                  ]),
                  _: 1
                }, 512), [
                  [_vShow, token.value]
                ]),
                _withDirectives(_createVNode(_component_router_link, {
                  type: "submit",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(changeComponentAuthorization)('login_component'))),
                  class: "d-flex a-i-center btn btn-default mt-4 btn-default-big start-button text-decoration-none text-center j-content-center",
                  to: { name: 'auth' }
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$tc("login")), 1)
                  ]),
                  _: 1
                }, 512), [
                  [_vShow, !token.value]
                ]),
                _withDirectives(_createVNode(_component_router_link, {
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(changeComponentAuthorization)('create_account'))),
                  class: "d-flex a-i-center btn btn-default btn-blue ml-4 mt-4 btn-default-big start-button text-decoration-none text-center j-content-center",
                  to: { name: 'auth' }
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$tc("Register")), 1)
                  ]),
                  _: 1
                }, 512), [
                  [_vShow, !token.value]
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})